import axios from "axios";
import { Box } from "@mui/material";
import localize from "../../../../common/localize";
import { useEffect, useState } from "react";
import ReportSectionTitle from "../../../../components/common/ReportSectionTitle";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import ValueOrNoDataLabel from "../../../../components/common/ValueOrNoDataLabel";
import {
  GetDateInMMDDYYYYFormat,
  getStatusText,
} from "../../../../common/utils";
import TableComponentForReport from "./TableComponentForReports";

export default function ReportGeneralRequests({ eventId }) {
  const { config, GENERAL_REQUESTS_ENDPOINT } = useGlobalContext();

  const [requests, setRequests] = useState([]);

  const getRequests = async () => {
    const requestConfig = {
      ...config,
      headers: {
        ...config.headers,
        Filter: JSON.stringify([
          {
            Name: "Event",
            FriendlyName: localize.event,
            FilterValue: {
              Value: eventId,
            },
            Value: eventId,
          },
        ]),
        Pagination: -1,
      },
    };
    const data = await axios.get(`${GENERAL_REQUESTS_ENDPOINT}`, requestConfig);

    if (data?.data?.Data?.length > 0) {
      setRequests([...data.data.Data]);
      return;
    }

    setRequests([]);
  };

  useEffect(() => {
    getRequests();
  }, []);

  return (
    <Box>
      <ReportSectionTitle title={localize.general_requests} />
      <div className="report_section_without_top_border">
        {requests?.length > 0 ? (
          <TableComponentForReport
            headers={[
              localize.type,
              localize.status,
              localize.client,
              localize.assigned_to,
              localize.expected_attention_date,
              localize.modified_by,
              localize.creation_date,
            ]}
            rows={requests.map((item) => [
              <ValueOrNoDataLabel
                hideBackground
                centerValue
                data={item?.Type?.Name}
              />,
              <ValueOrNoDataLabel
                hideBackground
                centerValue
                data={getStatusText(item?.Status)}
              />,
              <ValueOrNoDataLabel
                hideBackground
                centerValue
                data={item?.Client?.Name}
              />,
              <ValueOrNoDataLabel
                hideBackground
                centerValue
                data={
                  item?.PersonalAssigned
                    ? `${item.PersonalAssigned.SurName} ${
                        item.PersonalAssigned.LastName ?? ""
                      }`
                    : undefined
                }
              />,
              <p className="textAlignedCenter">
                {GetDateInMMDDYYYYFormat(new Date(item?.ExpectedSolutionDate))}
              </p>,
              <ValueOrNoDataLabel
                hideBackground
                centerValue
                data={item?.CreatedBy}
              />,
              <p className="textAlignedCenter">
                {new Date(item?.CreationDate).toLocaleString(undefined, {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </p>,
            ])}
          />
        ) : (
          <label className="report_little_text p-2">{localize.no_data}</label>
        )}
      </div>
    </Box>
  );
}
